import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Institution } from 'cb-model';

export interface InstitutionParentRow {
  id: number;
  parent_institution: number;
  child_institution: number;
}

export const InstitutionParent: Entity<InstitutionParentRow> = {
  id: 'InstitutionParent',
  title: 'Institution Parent',
  service: 'main',
  rowLabel: (row: InstitutionParentRow) => [row.parent_institution, row.child_institution].join(' / '),
  rowLabelDynamic: (row: InstitutionParentRow) =>
    `<lookup:Institution:${row.parent_institution}> / <lookup:Institution:${row.child_institution}>`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.institution_parent',
  },
  security: [
    {
      role: 'all',
      action: 'read',
      access: 'all',
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [],
  defaultFilters: [{ fieldId: 'parent_institution', operator: 'eq', value: '' }],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    parent_institution: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Parent Institution',
      persistence: PersistenceType.SetOnCreateOnly,
      mandatory: true,
      refEntity: Institution,
    },
    child_institution: {
      seq: 15,
      type: FieldType.Reference,
      label: 'Child Institution',
      persistence: PersistenceType.SetOnCreateOnly,
      mandatory: true,
      listColumn: true,
      refEntity: Institution,
    },
  },
};
